import { SUBSCRIPTIONS_URL } from "@constants/constants";
import axios from "axios";
interface subscribeToEmailProps {
  email: string;
  networks: string[];
}

export const subscribeToEmail = async (data: subscribeToEmailProps) => {
  return axios.post(`${SUBSCRIPTIONS_URL}/save`, data);
};
